import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled ? "border-background-200/70 bg-background-50/90 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-radar-line text-lg" />
          </span>
          <span className="font-label text-base font-bold tracking-wide text-foreground-900">
            免费黑料
            <span className="ml-1 hidden text-xs font-medium text-foreground-500 sm:inline">深挖 · 真相 · 独家</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            href="#tip"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-fire-line mr-1.5 text-base leading-none" />
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-lg`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 font-label text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#tip"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-fire-line mr-1.5 text-base leading-none" />
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}